export default {
  close: 'Close',
  dataIterator: {
    pageText: '{0}-{1} de {2}',
    noResultsText: 'Sense dades per mostrar',
    loadingText: 'Loading item...',
  },
  dataTable: {
    itemsPerPageText: 'Files per pàgina:',
    ariaLabel: {
      sortDescending: ': Sorted descending. Activate to remove sorting.',
      sortAscending: ': Sorted ascending. Activate to sort descending.',
      sortNone: ': Not sorted. Activate to sort ascending.',
    },
    sortBy: 'Sort by',
  },
  dataFooter: {
    itemsPerPageText: 'Elements per pàgina:',
    itemsPerPageAll: 'Tot',
    nextPage: 'Pàgina Següent',
    prevPage: 'Pàgina Anterior',
    firstPage: 'Pàgina Primera',
    lastPage: 'Pàgina Darrera',
  },
  datePicker: {
    itemsSelected: '{0} seleccionats',
  },
  noDataText: 'Sense dades',
  carousel: {
    prev: 'Visualització prèvia',
    next: 'Següent visual',
  },
  calendar: {
    moreEvents: '{0} més',
  },
  fileInput: {
    counter: '{0} files',
    counterSize: '{0} files ({1} in total)',
  },
}
